import Vue from 'vue'

import { Services } from '@sigma-frontend-libs/commons'

import render from './render'

export default {
  name: 'Item',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  methods: {
    editCallback() {
      Vue.router.push({
        name: `${Services['url-shortener-tracking']}.single`,
        params: { id: this.value.id }
      })
    }
  },

  render
}
